module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C423"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "C419"
  }, [_c('strong', [_vm._v("The historical context of Jesus and the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C476"
  }, [_vm._v("This chapter:")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("describes the historical sources that we can draw on;")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("outlines the history of the ‘intertestamental period’ (i.e. the period between the OT and NT) until the Roman takeover of Palestine in 63 BC, and then to the fall of Jerusalem in AD 70, drawing attention to particular significant events;")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("does the same for the Roman period until the fall of Jerusalem in AD 70;")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("highlights some of the key ingredients in Jesus’ context.")])]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_245"
    }
  }, [_vm._v("From")]), _vm._v(" the Persian period to the Jewish War")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Stained-glass windows are often beautiful, and express a deep piety. But the picture of Jesus and the early Christians which they portray is usually as remote from historical reality as it is from the contemporary reality of the modern observer or worshipper.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("To understand the NT we need to transport ourselves into the world of first-century Palestine, and to see Jesus in his historical, social and religious context. In that context he becomes a credible flesh-and-blood person, not a romantic religious icon.")]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_246"
    }
  }, [_vm._v("Sources")]), _vm._v(" of information")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("How do we know about Jesus’ context? What sources of information have we?")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_247"
    }
  }, [_vm._v("Old")]), _vm._v(" and New Testaments")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The Old and New Testaments are hugely informative – the NT directly since it comprises writings of the earliest Christian movement, and the OT indirectly, since it was the basis of the Jews’ understanding of themselves, their history and their religion.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_248"
    }
  }, [_vm._v("Jewish")]), _vm._v(" sources")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("There is a substantial body of Jewish literature deriving from the so-called ‘second temple’ period (approximately 538 BC to AD 70). Solomon’s temple was the first, the ‘second’ was that built in the period of Ezra and Nehemiah, as described in the OT, and then restored by Herod the Great. Historically, most important are:")]), _vm._v(" "), _c('p', {
    staticClass: "C484"
  }, [_c('strong', [_vm._v("The books of Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("These four books were written over a period of years (from about 100 BC onwards) by a number of different authors, and describe the period when the ‘Maccabees’ were Israel’s leading family, i.e. from 167 BC. The first book is the most valuable historically, and describes, from a very pro-Jewish, pro-Maccabean "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("viewpoint, the catastrophic events that took place in and after 167 BC (notably the setting up of the ‘abomination of desolation’) and the heroic Jewish response to these events. (See further below.)")]), _vm._v(" "), _c('p', {
    staticClass: "C484"
  }, [_c('strong', [_vm._v("The writings of Josephus")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Josephus, who lived from AD 37 to about AD 100, is easily our most important source of information about the times of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("He was a well-educated Jew who lived in Palestine until the Jewish War of AD 66–70. In the war he was a commander on the Jewish side, but then went over to the Romans, and thereafter lived in Rome.")]), _vm._v(" "), _c('div', {
    staticClass: "C486"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('em', [_vm._v("What do you think?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("JOSEPHUS ON JESUS")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Antiquities 18:63-64 (=18.3.3) reads: ‘About this time there lived Jesus, a wise man, if indeed one ought to call him a man. For he was one who wrought surprising feats and was a teacher of such people as accept the truth gladly. He won over many Jews and many of the Greeks. He was the Messiah. When Pilate, upon hearing him accused by men of the highest standing amongst us, had condemned him to be crucified, those who had in the first place come to love him did not give up their affection for him. On the third day he appeared to them restored to life, for the other prophets of God had prophesied these and countless other marvellous things about him. And the tribe of the Christians, so called after him, has still to this day not disappeared.’")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("What do you think might be original Josephus, and what is more likely Christian scribe?")])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("He wrote various books (partly to explain and defend himself), most notably a history of the "), _c('em', [_vm._v("Jewish War")]), _vm._v(", and then also a history of the Jewish people, the "), _c('em', [_vm._v("Antiquities")]), _vm._v(". Both are invaluable sources of information about Palestine in the NT period.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Exactly what he said about Jesus himself is uncertain, since his writings were preserved for us by Christian scribes who seem to have ‘Christianized’ his account of Jesus – in order, no doubt, to improve its accuracy, from their point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The changes made by the scribes were probably minor, but the result is that we cannot be certain what exactly Josephus wrote about Jesus. However, this does not seriously diminish the enormous value of Josephus’ description of the NT period.")]), _vm._v(" "), _c('p', {
    staticClass: "C484"
  }, [_c('strong', [_vm._v("The Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Probably the most famous archaeological discovery of the twentieth century was the finding of scrolls in caves by the Dead Sea in 1947. The story of their discovery (by a shepherd boy looking for a lost sheep and throwing stones – which then fell into the caves that had been undisturbed since the first century), and then of their dissemination and publication is an intriguing one. The scrolls were found in 11 caves, some well-preserved, some very fragmentary; they include copies of OT books, commentaries on OT books (called ‘pesharim’ by scholars, from a Hebrew word ‘pesher’ meaning interpretation), and other documents relating to the community whose library they were. These documents include books of hymns/psalms, instructions for the community’s life (e.g. on what to do if "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("assemblies!), books on the future and on the hidden purposes of God.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("SOME IMPORTANT DEAD SEA SCROLLS")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The scrolls are identified with a number relating to the cave they were found in, e.g. 4Q means cave 4 at Qumran, and then a letter or number identifying the scroll in question. Thus 4QpHab means the pesher (or commentary) on the OT book of Habakkuk found in cave 4 at Qumran.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Other important scrolls include:")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("1QS – the Community Rule, from cave 1, which gives instructions for the life of the Qumran community;")]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("1QH – the Hymn Scroll, a community hymnbook;")]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("1QM – the War Scroll, instructions for the future war of the ‘sons of light’ versus the ‘sons of darkness’.")])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The books are not histories, but are still of considerable interest to the historian (a) because of some historical allusions, (b) because they emanate from a first-century Palestinian Jewish group (most usually identified with the ‘Essenes’), and (c) because it is possible that the early Christian movement had something to do with this group – John the Baptist is sometimes thought to have been at Qumran.")]), _vm._v(" "), _c('p', {
    staticClass: "C484"
  }, [_c('strong', [_vm._v("Other Jewish sources")])]), _vm._v(" "), _c('p', {
    staticClass: "P10a"
  }, [_vm._v("Other Jewish sources that throw some light on the NT period include:")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the so-called Apocrypha – books not in the Hebrew Bible, but in the Greek translation of the OT, the Septuagint (commonly referred to as the LXX) and in the Roman Catholic OT. In the Apocrypha are the books of Maccabees (see above), and others such as Ecclesiasticus or the Wisdom of Ben Sira (written about 180 BC) and the Wisdom of Solomon (first century BC).")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the Pseudepigrapha – other writings such as 1 Enoch, some of them ascribed to sages of the past, including various ‘apocalyptic’ writings, containing heavenly visions of various sorts.")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the writings of the Jewish philosopher and politician Philo who came from Alexandria in Egypt and lived in the first century AD.")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the sayings of the Rabbis, recorded in the Mishnah (compiled about AD 200) and Talmud (about AD 400).")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the Targums, being Aramaic translations and paraphrases of the OT, which were probably current orally in the NT period but which were written down much later.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_207"
    }
  }, [_vm._v("Greek")]), _vm._v(" and Roman historians")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Palestine at the time of Jesus was part of the Roman empire, and for centuries before had been directly or indirectly controlled by the big empires that dominated what we would call the Mediterranean and the Middle East. For this reason the writings of the Greek and Roman historians (notably Polybius c.200–120 BC, Diodorus c.90–30 BC, Tacitus c.AD 56–120 and Suetonius c.AD 75–150) are important, even if they say little (or nothing) about the Christian movement itself. Tacitus refers to the Christian movement when he discusses the great fire of Rome in AD 64, "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("the Christians ("), _c('em', [_vm._v("Ann")]), _vm._v(". XV.38–44). Suetonius has a reference to the Jewish community in Rome being expelled from the city by the emperor Claudius, because they had been ‘rioting at the instigation of Chrestus’ ("), _c('em', [_vm._v("Claudius")]), _vm._v(" 25.4); this is plausibly taken to refer to troubles within the Jewish community over the activities of enthusiastic followers of Jesus Christus in the capital city.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("JOHN THE BAPTIST AND THE QUMRAN COMMUNITY")])]), _vm._v(" "), _c('p', {
    staticClass: "C476"
  }, [_vm._v("The Qumran community was a priest-led community. Luke tells us that John the Baptist was son of a priest (Luke 1–2):")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("Qumran was in the desert near where the river Jordan enters the Dead Sea. Luke tells us that John ‘was in the desert’ until the start of his ministry when he baptized in the river Jordan (Luke 1:80).")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("The Qumran community saw themselves as fulfilling prophecy, including Isa. 40:3, on preparing the Lord’s way in the desert (1QS 8:14). The NT applies this text to John (e.g. Mark 1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("The Qumran community was a pious protest movement against the religious hierarchy, who emphasized ritual washing and also the work of the ‘spirit of holiness’ (1QS 3). John called people out, denounced false religion and baptized people, speaking of a future baptism with the ‘Holy Spirit’.")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("The Qumran community were conscious of living in the last days and were looking forward to the coming of one or more Messiah. John announced the coming of God’s kingdom and of one greater than he.")])]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_208"
    }
  }, [_vm._v("Before")]), _vm._v(" the Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("The OT story ends in the Persian period, with the Jews returning from exile in Babylon (modern Iraq) to Palestine, their promised land. The return to their homeland (with all its historical and religious significance) was very important for the Jewish people. But it was far from being a straightforward return to former glory.")]), _vm._v(" "), _c('div', {
    staticClass: "C464"
  }, [_c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("Relatively few did actually return. Many remained in Babylonia; others had dispersed to other countries such as Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("The rebuilding was slow and, when eventually the temple in Jerusalem was rebuilt, it was a shadow of its former self. The wealth of Solomon was not available for the rebuilding, and there was opposition from other people in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("The returning Jews were still subject to the Persians and did not have a substantial army with which to defend themselves, so were vulnerable to opposition from others and to the whims of their Persian masters (see the books of Ezra and Nehemiah).")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Some of the local opposition came from people in the neighbouring region of Samaria, who seem to have been a hotch-potch of nationalities and religions. Although they professed some sort of allegiance to the God of Israel, the Jews were suspicious of their motives and hostile towards their offers of collaboration (Ezra 4). They regarded them as half-pagans at best. This cold-shouldering of the Samaritans is presumably one of the factors that led the Samaritans to build their own temple on Mount "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Gerizim, probably sometime in the fourth century BC. Inevitably this alternative temple in the promised land infuriated the Jews, and, although a lot happened between these events and the NT period, this is one of the roots of the Jew-Samaritan tensions that are evident in the NT.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The Persian period is important not just because it brought Jews back to Palestine, but also because it was a time when the Jews were struggling to maintain their own religious and social identity in a context of political powerlessness and economic weakness. For the pious it was important to maintain the traditional law of Moses, to keep themselves pure (from people like the Samaritans) and to uphold the sanctity of the temple (from people like the Samaritans!). Not that everyone felt this way. The temptation was to give up and to assimilate into the surrounding culture, and there is evidence that a significant number of Jews went a long way in that direction. Even among those who didn’t, there may have been more assimilation of ideas than they would have liked to admit. Thus the greater prominence of angels and demons in the NT by comparison with the OT may have something to do with Persian religious influence.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_209"
    }
  }, [_vm._v("The")]), _vm._v(" Greeks")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Philip, king of Macedonia in northern Greece, formed a united kingdom of Greece. He was succeeded by his son Alexander in 336 BC, who had been educated in part by the famous philosopher Aristotle. He proceeded to conquer the known world in a brilliant campaign that took him across the Persian empire to Egypt in the south and India in the east. He created probably the largest empire the world had ever known within about ten years, only to die prematurely in 323 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Although his empire did not last, his vision of spreading Greek culture was remarkably realized. He founded Greek cities, such as Alexandria in Egypt, and in the time of Jesus Greek was the international language of the day (rather like English is today). Ordinary people across the Roman empire, including in Palestine, could speak it. In the NT period there were synagogues where the worship was in Greek, and one of the early tensions in the Christian community was between Aramaic-speaking Christians and Greek-speakers. But Greek was generally a positive thing for the early Christians, facilitating mission across the Roman empire.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("A power struggle followed Alexander’s death, and his huge empire was divided – Palestine was first ruled by the Ptolemies of Egypt. There was a lot of traffic between Palestine and Egypt, with many Jews settling there, so that the great city of Alexandria had a large Jewish minority. But then control of Palestine passed to the Seleucids, whose capital was in Syrian Antioch.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The Ptolemies, like the Persians, had followed a rather lenient, hands-off approach towards the Jews, allowing them religious freedom and considerable autonomy. But this policy began to give way under the Seleucids, who were themselves under some pressure from the Romans who had imposed punitive financial reparations on them after a military defeat.")]), _vm._v(" "), _c('table', {
    staticClass: "C71",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T5_FirstRow"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("RULING EMPIRE")])])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("EFFECTS IN JUDEA")])])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("WRITINGS ETC.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T5_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("BC")])]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("600")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C49"
  }, [_vm._v("597-539 - BABYLON")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("538 - PERSIA")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C49"
  }, [_vm._v("597 Jerusalem taken by Nebuchadnezzar Il.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("587 Jerusalem destroyed. People go into exile.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C49"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "T5_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("500")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("PERSIA")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C51"
  }, [_vm._v("539 Cyrus of Persia conquers Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("538 Return of exiles to Jerusalem, rebuilding of temple begun.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("516 Temple completed.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C49"
  }, [_vm._v("450 approx - Ezra and Nehemiah in Jerusalem.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T5_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("400")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("PERSIA")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_c('span', [_vm._v("332")]), _vm._v("- GREECE")]), _vm._v(" "), _c('p', {
    staticClass: "C70"
  }, [_c('span', {
    staticClass: "C63"
  }, [_vm._v("332")]), _vm._v("Alexander conquers, builds cities.")]), _vm._v(" "), _c('p', {
    staticClass: "C70"
  }, [_c('span', {
    staticClass: "C63"
  }, [_vm._v("323")]), _vm._v("Death of Alexander. Greek empire divided.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_c('span', [_vm._v("323")]), _vm._v("- EGYPT Ptolemies rule.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C56"
  }, [_vm._v("323 Judea is in the area under Ptolemy rule.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_vm._v("Spread of Greek thought and language.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T5_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("300")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p')]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_vm._v("High priests rule in Jerusalem on behalf of the Ptolemies.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "T5_LastRow"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("200")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("SYRIA")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("198 Seleucids take over Palestine from Ptolemies.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("190 Romans inflect major defeat on Seleucids and impose reparations.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("Antiochus IV ‘Epiphanes’ enthroned (ruled 175-163).")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C51"
  }, [_vm._v("Seleucid empire in control in place of the Ptolemies.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("High priest in Jerusalem favours Antiochus Epiphanes, but in 167 Antiochus desecrates the temple and builds an altar to Zeus Olympus (desolating sacrilege).")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("166 Death of Mattathias; Judas Maccabeus becomes leader of revolt.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("164 Judas cleanses temple; battles with Syria.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("Hasmonean dynasty")])]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("167 Onwards Maccabees dominant in Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("160 Death of Judas.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("160-152 Jonathan leader of forces; becomes high priest in 152.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("143 Jonathan killed, succeeded by brother Simon.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("134 Hyrcanus I succeeds.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("128 Jews destroy Samaritan temple on Mount Gerizim.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("104 Aristobulus I; 103 Alexander Janneus (his brother);")]), _vm._v(" "), _c('p', {
    staticClass: "C60"
  }, [_vm._v("76 Alexandra (wife); 67 Hyrcanus II and Aristobulus (sons). Hasmoneans ruled until 63 BC.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C49"
  }, [_vm._v("Previous century and this century: Septuagint translation of OT into Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "C52"
  }, [_vm._v("200-120 BC Polybius, Roman historian.")]), _vm._v(" "), _c('p', {
    staticClass: "C51"
  }, [_vm._v("159 approx - Essene Teacher of Righteousness.")]), _vm._v(" "), _c('p', {
    staticClass: "C49"
  }, [_vm._v("Development of Pharisees and Essenes.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T4_FirstRow"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("100")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("63 — ROME")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("63")]), _vm._v("Jerusalem taken by Pompey.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("44")]), _vm._v("Julius Caesar murdered in Rome.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("High priests rule under the Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("Civil wars break out in the Roman world.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("The Herods")])]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("55")]), _vm._v("Antipater (father of Herod the Great) given title procurator of Judea.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("40")]), _vm._v("Herod son of Antipater declared king of Judea in Rome; he appoints his supporters as high priests.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C44"
  }, [_vm._v("37-4")]), _vm._v("Herod the Great rules.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("19")]), _vm._v("Herod starts rebuilding temple (consecrated 9 BC).")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C33"
  }, [_vm._v("4")]), _vm._v("Death of Herod; kingdom divided:")]), _vm._v(" "), _c('p', {
    staticClass: "C74"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("(1)")]), _vm._v("Herod Antipas rules Galilee and Perea until AD 38; marries Herodias.")]), _vm._v(" "), _c('p', {
    staticClass: "C74"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("(2)")]), _vm._v("Herod Archelaus rules Judea, Samaria, Idumea (deposed in AD 6).")]), _vm._v(" "), _c('p', {
    staticClass: "C74"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("(3)")]), _vm._v("Philip rules Northern Palestine until AD 34.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_vm._v("100 BC onwards - Four books of Maccabees written.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("Also Ecclesiasticus, The Wisdom of Ben Sira (c. 180 BC) and Wisdom of Solomon.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("90-30 Diodorus, Roman historian.")]), _vm._v(" "), _c('p', {
    staticClass: "C30"
  }, [_vm._v("4 BC approx date of Jesus’ birth.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T4_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("AD 1")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_c('strong', [_vm._v("The Caesars")])]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("14")]), _vm._v("Augustus (emperor) dies.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("14-37")]), _vm._v("Tiberius.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("37-41")]), _vm._v("Gaius.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("41-54")]), _vm._v("Claudius.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("49")]), _vm._v("Jews expelled from"), _c('br'), _vm._v("\nRome by Claudius.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("54")]), _vm._v("Jews return to Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("54-68")]), _vm._v("Nero.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("Fire of Rome; persecution of Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("68-69")]), _vm._v("Year of four emperors:"), _c('br'), _vm._v("\nGalba, Otho, Vitellius, Vespasian.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("69-79")]), _vm._v("Vespasian.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("79-81")]), _vm._v("Titus,")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("81-96")]), _vm._v("Domitian.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("96-98")]), _vm._v("Nerva.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("AD 6")]), _vm._v("Judea and Samaria become a Roman province ruled by Roman prefects. Census riots.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("18")]), _vm._v("Caiaphas becomes high priest.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("26-37")]), _vm._v("Pontius Pilate is Roman procurator.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("3?")]), _vm._v("Roman governor Gaius orders statue of himself set up in Jerusalem temple.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("40")]), _vm._v("Herod Agrippa becomes king in the north, 41 also king in the south, after assassination of Gaius.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("44")]), _vm._v("Famine; death of Herod Agrippa.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("52")]), _vm._v("Roman governor Cumanus removed from office for poor handling of Jews and Samaritans. Felix succeeds.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("59-62")]), _vm._v("Festus Governor.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("63")]), _vm._v("Temple completed.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("66-70")]), _vm._v("Jewish war.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("70")]), _vm._v("Titus takes Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("74")]), _vm._v("Capture of Masada - last stronghold of the Jews")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_vm._v("c.31-33 Crucifixion of Jesus; c.1-4 years after: Conversion of Saul.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("37-100 Life of Josephus.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("41")]), _vm._v("Agrippa executes James the brother of John.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("Late 40s-late 50s Paul's missionary journeys.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("49-51 Paul in Corinth.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("Jewish philosopher and diplomat Philo lived in this century.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_vm._v("Tacitus (56-!20) and Suetonius (75-150) Roman historians.")]), _vm._v(" "), _c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("62")]), _vm._v("James brother of Jesus killed by high priest Annas II.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T4_Row"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("100.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_c('span', {
    staticClass: "C44"
  }, [_vm._v("98-117")]), _vm._v("Trajan.")]), _vm._v(" "), _c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("117-138")]), _vm._v("Hadrian.")]), _vm._v(" "), _c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("138-161")]), _vm._v("Antoninus Pius.")]), _vm._v(" "), _c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("161-180")]), _vm._v("Marcus Aurelius.")]), _vm._v(" "), _c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("180-192")]), _vm._v("Commodus.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C18"
  }, [_vm._v("115-117")]), _vm._v("Jewish revolts in Egypt, Cyrene, Cyprus.")]), _vm._v(" "), _c('p', {
    staticClass: "C35"
  }, [_c('span', {
    staticClass: "C37"
  }, [_vm._v("132")]), _vm._v("Hadrian makes antisemitic laws - temple of Jupiter in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "C45"
  }, [_c('span', {
    staticClass: "C27"
  }, [_vm._v("133-5")]), _vm._v("Rebellion of Simeon Bar Kochba.")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("Pliny governor of Bithynia.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("110-115 Letters of Ignatius.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("Justin Martyr (d. 165).")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("Polycarp (d. 156).")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("lrenaeus, Bishop of Lyon 180s-190s.")]), _vm._v(" "), _c('p', {
    staticClass: "C28"
  }, [_vm._v("Tertullian c. 160-220.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T4_LastRow"
  }, [_c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  }, [_vm._v("200")])]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  })]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C28"
  })]), _vm._v(" "), _c('td', {
    staticClass: "C12"
  }, [_c('p', {
    staticClass: "C25"
  }, [_vm._v("Mishnah (Sayings of the Rabbis) compiled.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("The Maccabees versus the Seleucid Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Things came to a head with the Seleucid ruler, Antiochus 4, who ruled from 175 to 163 BC, and who took the name ‘Epiphanes’. The name means something like ‘manifestation’, and represented a claim to be a divine manifestation. He was motivated by enthusiasm for hellenizing the world (i.e. spreading Greek culture and religion), and by the need to raise funds. This led him to interfere in the religious affairs of the Jews, notably over the appointment of the high priest in Jerusalem. The high priesthood was the highest and most sacred position that a Jew could hold, and Antiochus twice intervened to put in men who would support him financially and support his Hellenizing. His first appointment, Jason, built a gymnasium near the temple in Jerusalem, where Greek games could be held – something very alien to Jewish culture – and his second, Menelaus, was not even from the proper high priestly family.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Such meddling by the arrogant superpower was resented, and sparked off a series of events, which eventually led to Antiochus attacking Jerusalem, killing many of his opponents and looting the temple. He went on to attempt forcibly to impose Hellenistic culture and religion on the city. He prohibited the observance of the Jewish law, including the circumcision of baby boys, and, most offensively of all, rededicated the temple to Olympian Zeus, erecting a pagan altar. This ‘desolating sacrilege’ remained in place from 167 until 164 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("His attempts to annihilate Judaism failed, thanks to the heroic resistance of the people, led and inspired by one particular priestly family, the Hasmoneans. Mattathias refused to offer a pagan sacrifice in his village of Modein, and then called people to flee to the mountains: ‘Let everyone who is zealous for the law and supports the covenant come out with me!’ (1 Macc. 2:27). A courageous guerrilla campaign ensued, under the leadership of his sons. The first and most famous of these was Judas (whose nickname Maccabeus – ‘hammer’ – became attached to the whole family of the ‘Maccabees’). He led a series of daring attacks on the Seleucid forces, which resulted eventually in their tactical withdrawal and to the rededication of the temple by the Jews in 164 BC, something that has been celebrated by Jews ever since in the Feast of Dedication (‘Hanukkah’ in Hebrew; referred to in John 10:22).")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("It is hard to over-emphasize the importance of these events for the NT. The actions of Antiochus came to epitomize for the Jews the ultimate disaster, and in the centuries that followed there was continual anxiety about the possible repetition of the horrific events. This fear is reflected in Jesus’ use of the idea of ‘the desolating sacrilege’ when referring to future disaster coming on Jerusalem in Mark 13:14, and in Paul’s references to ‘the man of lawlessness’ setting himself up in the temple in 2 Thess. 2. The actions of the Maccabees and those with them became the epitome of religious courage and faithfulness in the face of powerful paganism. Their zeal was the inspiration of numerous freedom fighters and so-called ‘zealots’ in Jesus’ lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The Hasmonean Dynasty")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The victory of Judas was famous, but not the end of the story, and in the years that followed there were many ups and downs, with the Seleucids continuing to exert a controlling influence on affairs in Jerusalem to a greater or lesser extent. Judas himself was killed, as were his brothers Jonathan and Simon who succeeded him in turn. But a family dynasty had been established, and the Hasmonean family continued to rule until 63 BC, when Judea became a part of the Roman empire.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The Hasmonean period was up and down in all sorts of ways. Politically and militarily there were successes, as when Simon achieved freedom from Seleucid taxation for Judea, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("and also when Hyrcanus 1 (son of Simon) conquered Samaria, Idumea and part of Galilee, forcing their residents to accept Judaism and circumcision. Josephus describes the attack on Samaria as a prolonged and brutal affair, which included the destruction of the Samaritans’ temple in 128 BC. It is easy to see how this would have left deep wounds in the mind of the Samaritans in the time of Jesus. There were also moments of humiliation, notably in 63 BC when a family feud led to an invitation to the Romans, under the leadership of Pompey, to intervene.")]), _vm._v(" "), _c('div', {
    staticClass: "C486"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('em', [_vm._v("What do you think?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("THE DESOLATING SACRILEGE")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("1 Macc. 1:41–61:")]), _vm._v(" "), _c('div', {
    staticClass: "C493"
  }, [_c('p', {
    staticClass: "C399"
  }, [_vm._v("Then the king wrote to his whole kingdom that all should be one people, and that all should give up their particular customs. All the Gentiles accepted the command of the king. Many even from Israel gladly adopted his religion; they sacrificed to idols and profaned the Sabbath. And the king sent letters by messengers to Jerusalem and the cities of Judah; he directed them to follow customs strange to the land, to forbid burnt offerings and sacrifices and drink offerings in the sanctuary, to profane Sabbaths and festivals, to defile the sanctuary and the priests, to build altars and sacred precincts and shrines for idols, to sacrifice swine and other unclean animals, and to leave their sons uncircumcised. They were to make themselves abominable by everything unclean and profane, so that they would forget the law and change all the ordinances. He added: ‘And whoever does not obey the command of the king shall die.’")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("In such words he wrote to his whole kingdom. He appointed inspectors over all the people and commanded the towns of Judah to offer sacrifice, town by town. Many of the people, every one who forsook the law, joined them, and they did evil in the land; they drove Israel into hiding in every place of refuge they had.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Now on the fifteenth day of Chislev, in the one hundred and forty-fifth year, they erected a desolating sacrilege on the altar of burnt offering. They also built altars in the surrounding towns of Judah, and offered incense at the doors of the houses and in the streets. The books of the law which they found they tore to pieces and burned with fire … On the twenty-fifth day of the month they offered sacrifice on the altar which was on the top of the altar of burnt offering. According to the decree, they put to death the women who had their children circumcised, and their families and those who circumcised them; and they hung the infants from their mothers’ necks.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("But many in Israel stood firm and were resolved in their hearts not to eat unclean food. They chose to die rather than to be defiled by food or to profane the holy covenant; and they did die. Very great wrath came upon Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("What was offensive in the actions of Antiochus? What differing attitudes were evident among the Jews? Why?")])]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_193"
    }
  }, [_vm._v("KEY")]), _vm._v(" DATES")])]), _vm._v(" "), _c('p', {
    staticClass: "C476"
  }, [_c('strong', [_vm._v("From the OT to the Roman takeover")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("BC")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T514_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("538")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Release of Jews from exile under Cyrus the Persian.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("336")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Alexander the Great becomes king of Macedonia in northern Greece.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("323")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Death of Alexander leads to the division of his great empire: Ptolemy founds the Ptolemaic empire in Egypt with capital Alexandria.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("312")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Seleucus founds Seleucid empire with capital Antioch in Syria.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("198")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Palestine, which until now was part of the Ptolemaic empire, is taken over by the Seleucids after battle at Paneion.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("190")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Seleucid king, Antiochus 3, is seriously defeated by Romans at Lydia and forced to make large payments to Rome.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("167")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Antiochus 4 sets up pagan altar, ‘the desolating sacrilege’, in Jerusalem temple and tries to eradicate Jewish religion.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T514_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("164")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Temple rededicated after successful campaign by Judas Maccabeus, from the Hasmonean family.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("160")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Judas killed, and his brother Jonathan takes over.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("152")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Jonathan accepts position of high priest, though not himself from Zadokite high-priestly family.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("143")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Jonathan killed and succeeded by his brother Simon, who soon achieves freedom from taxation for Judea.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("134")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Simon assassinated; succeeded by his son Hyrcanus 1.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("128")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Hyrcanus’s forces destroy Samaritan temple on Mount Gerizim.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("104")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Aristobulus 1 succeeds his father Hyrcanus; conquers Galilee.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("103")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Aristobulus dies suddenly, and is succeeded by his brother Alexander Janneus, who greatly expands territory, and takes title king of Judea.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("76")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Alexander dies, and is succeeded by his wife Alexandra, who favours the Pharisees (whom her husband had oppressed).")])]), _vm._v(" "), _c('tr', {
    staticClass: "T515_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("63")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Pompey and the Romans take over Jerusalem.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Theologically it was also a period of ups and downs. In the original successful campaign against the Seleucids, Judas and his brothers were enthusiastically supported by pious Jews, including the so-called hasidim (pious ones), who may well have been the forerunners of later movements such as the Pharisees and the Essenes. But relations became very strained later, when the Hasmoneans took increasing "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("powers to themselves. Thus Jonathan (who succeeded Judas) allowed himself to be regarded as high priest, and Aristobulus a generation later took the title of ‘king’. This establishment of a high-priestly and royal dynasty was unacceptable to strictly pious Jews – the Hasmoneans were not from the high priestly line nor from the family of David. Things reached rock bottom with Alexander Janneus (brother and successor of Aristobulus), who ruled from 103 to 76 BC. He was militarily successful, but more interested in power than piety, and he came into violent conflict with the Pharisees, among others. Josephus says that he crucified hundreds of Pharisees and killed in all over 50,000 of his opponents.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The situation was redeemed to some extent by Alexander’s wife, Alexandra, who succeeded him on his death, and favoured the Pharisees, but the relief was temporary, since it was the squabbling of her sons, Hyrcanus 2 and Aristobulus, that led to the Roman intervention and the end of the Hasmonean dynasty.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_194"
    }
  }, [_vm._v("HASMONEAN")]), _vm._v(" LEADERS OF JUDEA 167–63 BC")])]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T517_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("167")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Mattathias")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("166")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Judas (son)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("160")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Jonathan (brother)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("143")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Simon (brother)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("134")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Hyrcanus 1 (son)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("104")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Aristobulus 1 (son)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("103")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Alexander Janneus (brother)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("76")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Alexandra (wife)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T517_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("67")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Hyrcanus 2 and Aristobulus 2 (sons)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("("), _c('em', [_vm._v("Relationship to predecessor in brackets")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_210"
    }
  }, [_vm._v("The")]), _vm._v(" Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The republic of Rome had been growing increasingly powerful in the Mediterranean situation in Egypt. He was rewarded by being made governor of Judea and later by the granting of particular privileges in the Roman empire to the Jews (e.g. they were world for two centuries, and the first century BC saw its formidable armies under their powerful leaders (the most famous being Pompey, Julius Caesar, Anthony and Octavian, later called Augustus when he was emperor), taking over what had once been Alexander the Great’s empire – from Turkey, into Syria and to Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("In 63 BC Pompey entered Jerusalem, including the Holy of Holies (the central shrine in the Jerusalem temple). This caused offence, but Pompey had no anti-Jewish agenda, and the immediate impact of the arrival of Rome was not huge, since Hyrcanus 2 – one of Alexandra’s "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("squabbling sons – was given authority to rule in Jerusalem under the Romans.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("KEY ROMAN HISTORIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_c('strong', [_vm._v("Tacitus")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("AD 56–120 approx, an influential Roman, who wrote two major works on Roman history: the "), _c('em', [_vm._v("Annales")]), _vm._v(", 18 volumes covering the period of AD 14–68, and the "), _c('em', [_vm._v("Historiae")]), _vm._v(", covering the period AD 69–96. He describes the Christians as ‘a deadly sect’ ("), _c('em', [_vm._v("Ann")]), _vm._v(". XV.44.2–8).")]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_c('strong', [_vm._v("Suetonius")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("AD 75–150 approx, wrote ‘The Lives of Twelve Emperors’, starting with Caesar and ending with Domitian, i.e. the second half of the first century BC and most of the first century AD.")])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The impact was, however, considerable as time went on, since the Romans were now the power to reckon with, and everyone with aspirations to positions of political power and influence (which included the high priests) had to look to Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_211"
    }
  }, [_vm._v("The")]), _vm._v(" Herod family")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The famous family to come to prominence under the Romans was that of Antipater, father of the man known to us as Herod the Great. Antipater was a cunning politician (apparently from an Idumean or Edomite family, the Idumeans having been conquered and forced to accept Judaism in the heyday of the Hasmoneans). He had supported Hyrcanus in his quarrel with his brother, and soon managed to ingratiate himself with the Romans, notably by giving military aid to the Roman leader Julius Caesar, when he was in a dangerous exempted from regular military service, and were allowed to meet for worship).")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Neither Antipater nor Julius Caesar lasted long, both being assassinated. But Antipater’s younger son, Herod, in the face of considerable opposition, established himself in the favour of the Romans, and with their help fought his way into Jerusalem and into power. His ruthless campaign ended in 37 BC with a three-month siege of Jerusalem. From then on until his death in 4 BC, he was supreme in Jerusalem, king of all Judea, Samaria and Galilee.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Two characteristics are notable about Herod’s rule: first, his insecurity – political, to start with, and psychological. Having fought his way into power, he faced continuing opposition and uncertainty for the early years of his reign. He successfully played off different Roman leaders against each other, and ruthlessly put down internal opposition to his rule. Members of his own family, including his father-in-law and his wife Mariamme (of whom he was very fond, but who had Hasmonean blood in her), fell foul of his suspicions and were killed. In due course he became firmly established in power; but he continued to be nervous, and in the latter years of his life he was obsessed about possible threats to his position. Three of his own sons were executed, including his favourite Antipater, just days before Herod’s own death. Herod’s Palestine was a police state, living in fear. As for Herod’s family, the emperor Augustus may not actually have said, ‘It is better to be Herod’s pig than his son’, but he might appropriately have done so (Macrobius "), _c('em', [_vm._v("Saturnalia")]), _vm._v(" II iv 11). The account in Matthew’s Gospel of Herod’s murderous reaction to the announcement of the birth of a ‘king of the Jews’ (Matt. 2:2) is entirely in character.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("A second more positive characteristic of Herod’s reign was his achievement as a builder. He built fortresses, palaces, temples and theatres. For example, by the Dead Sea there was Machaerus on the East coast, where John the Baptist was imprisoned and finally executed, and Masada, the magnificent hill-top fortress complex on the west side of the Dead Sea, where the Jews would so heroically resist the Romans in the war of AD 66–70. Herod built the port of Caesarea on the Mediterranean, providing a massive artificial harbour on a coast where there is hardly any natural harbour. This became the key entry/exit point to the country, through which almost everyone would have "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("passed (including the apostle Paul following his arrest, Acts 23:33). Herod did great building work in Samaria, but most famous of all was his work in the Jerusalem area, where he built a whole variety of buildings, including a palace for himself, a theatre, an amphitheatre and a hippodrome, where crowds would come to watch sports and shows.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("It was, however, his work on the Jerusalem temple that was most striking and is most important for NT studies. This was started around 19 BC. The work on the main part of the temple took about ten years to complete, but the whole work went on until AD 63 – just a few years before it was to be destroyed by the Romans in AD 70. Nehemiah’s temple was a modest affair, not in good repair when Herod came to power. He, however, transformed it into one of the wonders of the ancient world, employing a huge workforce – Josephus speaks of 18,000 being unemployed when the work finally stopped in AD 63. He extended the temple area so as to cover twice the area of the original temple built by Solomon (Herod’s temple was about 500 yards long, 325 yards wide); the central shrine was surrounded by courtyards, colonnades and other surrounding buildings, built and decorated magnificently, with gold and silver and ornamental gateways (see "), _c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 34–35")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The importance of the temple for a study of the NT is clear. The Jews had very mixed feelings about Herod: he was ruthless, and he taxed them heavily, as he needed to, to pay for his building work and his own lavish lifestyle. He was seen as an outsider (as an Idumean) and not as a proper Jew. Culturally he was more Greek than Jewish, as his building programme showed (it included building temples to the Roman imperial family), in the use of Greek as the court language and in his own lifestyle. However, despite everything, the temple, which he did so much for, was something that inspired admiration and devotion.")]), _vm._v(" "), _c('div', {
    staticClass: "C486"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('em', [_vm._v("What do you think?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("HEROD ANTIPAS’ EXECUTION OF JOHN THE BAPTIST")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Compare the account in Mark 6:14–29 with that of Josephus Ant. 18:116–119 (=18.5.2):")]), _vm._v(" "), _c('div', {
    staticClass: "C493"
  }, [_c('p', {
    staticClass: "C399"
  }, [_vm._v("To some of the Jews the destruction of Herod’s army seemed to be divine vengeance, and certainly a just vengeance, for his treatment of John, surnamed the Baptist. For Herod had put him to death, though he was a good man and had exhorted the Jews to lead righteous lives, to practise justice towards their fellows and piety towards God, and so doing to join in baptism. In his view this was a necessary preliminary if baptism was to be acceptable to God. They must not employ it to gain pardon for whatever sins they committed, but as a consecration of the body implying that the soul was already thoroughly cleansed by right behaviour. When others too joined the crowds about him, because they were aroused to the highest degree by his sermons, Herod became alarmed. Eloquence that had so great an effect on mankind might lead to some form of sedition, for it looked as if they would be guided by John in everything that they did. Herod decided therefore that it would be much better to strike first and be rid of him before his work led to an uprising, than to wait for an upheaval, get involved in a difficult situation and see his mistake. Though John, because of Herod’s suspicions, was brought to Machaerus, the stronghold that we have previously mentioned, and there put to death, yet the verdict of the Jews was that the destruction visited upon Herod’s army was a vindication of John, since God saw fit to inflict such a blow on Herod.")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("How do the accounts of Mark and Josephus differ? To what extent do they contradict or complement each other?")])]), _vm._v(" "), _c('p', {
    staticClass: "C508"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    staticClass: "C685",
    attrs: {
      "alt": "",
      "src": "Images/33_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Herod died in 4 BC, and in his will left his domain to the three of his sons in whom he still had confidence – he bequeathed Judea and Samaria (including the title ‘king of Judea’) to Archelaus; Galilee and Perea to Antipas; and parts of Northern Transjordan and Gaulinitis (the area of the Golan Heights) to Philip. All three sons headed off to Rome, to gain Roman support; Antipas pressed his claim over against that of Archelaus. A delegation of Jews also went asking that none of the Herodians be appointed king. However, the Roman emperor Augustus eventually confirmed the will, except that he declined to give Archelaus the title of ‘king’.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("During the gap between the death of Herod and the establishment of his sons, there were various anti-Roman risings in Jerusalem, in Judea (led by a shepherd Athronges) and in Galilee (led by a man called Judas, who took over the Galilean town of Sepphoris). This revolt led the Roman governor of Syria to march into Palestine with his legions: he destroyed Sepphoris, a new town near Nazareth, and had 2,000 Jews in Jerusalem put to death by crucifixion.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Of the Herod sons, the two who are of most interest from a NT point of view are:")]), _vm._v(" "), _c('div', {
    staticClass: "C464"
  }, [_c('p', {
    staticClass: "C552"
  }, [_c('span', {
    staticClass: "C432"
  }, [_c('strong', [_vm._v("a.")])]), _c('strong', [_vm._v("Archelaus")]), _vm._v(" His brutality and his interference in temple affairs (e.g. in deposing two high priests) made him a hated man and, in response to delegations from Judea and Samaria, he was removed from office by the Romans in AD 6 (Matt. 2:22). Direct Roman rule was then being imposed.")]), _vm._v(" "), _c('p', {
    staticClass: "C552"
  }, [_c('span', {
    staticClass: "C432"
  }, [_c('strong', [_vm._v("b.")])]), _c('strong', [_vm._v("Herod Antipas")]), _vm._v(" He was a much more able ruler, who ruled in Galilee until AD 39. He followed his father as a builder, for example building a magnificent city, Tiberias, on the west shore of Lake Galilee. He was more sensitive to Jewish feelings and scruples than others in his family, though he upset the pious Jews by divorcing his wife and marrying Herodias, who had been married to a brother of his. He was denounced among others by John the Baptist, a popular prophet. Herod arrested John, and in due course executed him, at the instigation of Herodias.")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Herodias eventually proved the downfall of her husband, when she, with her usual ambition, persuaded Antipas to ask the Romans for the honour and title of king. The Romans suspected his ambitions, and he was rewarded with being deposed from office and sent to exile in France.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Although Jesus’ ministry was mostly in Antipas’s Galilean territory, the Gospels only describe them meeting once, in Jerusalem after Jesus had been arrested (Luke 23:6–12). Herod had heard plenty about Jesus (e.g. Mark 6:14), "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("but it may be that Jesus deliberately kept out of the way of the man who killed his friend and mentor John the Baptist (cf. Luke 13:31–33). Jesus is never described as visiting the big Greek towns of Sepphoris and Tiberias where Herod’s influence and rule will have been strongest. Jesus, then, was in Antipas’ territory when ministering in Galilee, though villages to the north like Bethsaida and Caesarea Philippi were in Philip’s territory. But when he visited Jerusalem he left Antipas’ jurisdiction.")]), _vm._v(" "), _c('p', {
    staticClass: "C508"
  }, [_c('span', {
    attrs: {
      "id": "id_195"
    }
  }, [_c('img', {
    staticClass: "C687",
    attrs: {
      "alt": "",
      "src": "Images/35_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Judea and Samaria had been under the direct rule of the Romans, in the form of a Roman governor (a ‘prefect’ or ‘procurator’), since the time of Archelaus.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Although Archelaus had been much disliked, direct rule was not universally welcomed by the Jews, since it represented the extending of pagan rule over their land. In fact, when it was first "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("introduced in AD 6, there was a major rebellion against a census conducted, for taxation purposes, by Quirinius, the Roman governor of Syria. The census was resented for both financial and theological reasons. The rebellion was led by a Judas from Galilee, but was swiftly crushed.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("CAIAPHAS’ TOMB?")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("In 1990 the tomb of a wealthy family was found near Jerusalem, and it was identified as the tomb of the high-priestly family of Caiaphas. It contained ossuaries (stone boxes for the bones of the deceased), one of which was said to have the high priest’s full name ‘Joseph son of Caiaphas’ inscribed on it. There are some questions about the identification, though not about the existence of Caiaphas!")])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("We need not delay to comment on the first three governors of Judea. The fourth was Valerius Gratus, who ruled from AD 15 to 26 and who seems to have been less conciliatory to the Jews than his predecessors. He kept deposing the high priest, until finally lighting on Joseph Caiaphas, who was high priest from AD 18 to 36.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_212"
    }
  }, [_vm._v("Pontius")]), _vm._v(" Pilate")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Easily the most famous Roman governor was Pontius Pilate, who was appointed in AD 26. He may have been a protégé of Sejanus, a very powerful figure in the Roman imperial court with anti-Jewish tendencies. Certainly he managed to offend the Jews soon after taking office. For example, breaking with earlier precedent, he ordered the Roman troops who were stationed in Jerusalem to carry their military standards into the city; the Jews were infuriated at what they saw as pagan images entering the holy city. The popular protests eventually forced Pilate to withdraw the order.")]), _vm._v(" "), _c('div', {
    staticClass: "C486"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('em', [_vm._v("What do you think?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C487"
  }, [_c('strong', [_vm._v("PILATE AND THE STANDARDS")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("Text of Josephus "), _c('em', [_vm._v("JW")]), _vm._v(" 2:169–77 (= 2.9.2–3):")]), _vm._v(" "), _c('div', {
    staticClass: "C493"
  }, [_c('p', {
    staticClass: "C399"
  }, [_vm._v("Pilate being sent by Tiberius as procurator in Judea, introduced into Jerusalem by night and under cover, the effigies of Caesar which are called standards. This proceeding, when day broke, aroused immense excitement among the Jews; those on the spot were in consternation, considering their laws to have been trampled under foot, as those laws permit no image to be erected in the city; while the indignation of the townspeople stirred the country-folk, who flocked together in crowds. Hastening after Pilate to Caesarea, the Jews implored him to remove the standards from Jerusalem and to uphold the laws of their ancestors. When Pilate refused, they fell prostrate around his house and for five whole days and nights remained motionless in that position.")]), _vm._v(" "), _c('p', {
    staticClass: "C494"
  }, [_vm._v("On the ensuing day Pilate took his seat on his tribunal in the great stadium and summoning the multitude, with the apparent intention of answering them, gave the arranged signal to his armed soldiers to surround the Jews. Finding themselves in a ring of troops, three deep, the Jews were struck dumb at this unexpected sight. Pilate, after threatening to cut them down, if they refused to admit Caesar’s images, signalled to the soldiers to draw their swords. Thereupon the Jews, as by concerted action, flung themselves in a body on the ground, extended their necks, and exclaimed that they were ready rather to die than to transgress the law. Overcome with astonishment at such intense religious zeal, Pilate gave order for the immediate removal of the standards from Jerusalem.")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("What do we learn from this passage about the Jewish context in which Pilate was governor? How does Pilate come over as a person?")])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("In a rather similar incident Pilate upset people by trying to have some golden shields inscribed with his name and that of the emperor erected in Herod’s palace in Jerusalem. This time the Jews protested to the Roman emperor himself, who told Pilate to move them to Caesarea. Pilate also caused offence by raiding the temple treasury to help pay for an aqueduct into the city. This secular (even if admirable) use of sacred funds again led to protests and violence.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Pilate’s dealings with Jesus and the Jewish authorities, at the time of Jesus’ arrest, must be seen in the context of (a) Pilate’s previous record of poor relations with the Jews, which will have made his position vulnerable in all sorts of ways (e.g. to the threat of being denounced to Rome); and (b) the general resentment in Palestine against foreign rule, a resentment that burst into flame from time to time. The Gospels refer to ‘an insurrection’ at the time of Jesus, and to ‘bandits (or robbers)’ being crucified with Jesus, who could have been nationalist freedom fighters (Luke 23:25).")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_196"
    }
  }, [_vm._v("LEADERS/")]), _vm._v("RULERS OF JUDEA IN THE ROMAN PERIOD")])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("BC")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T519_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("55")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Antipater (HF)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T519_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("40")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Herod the Great (HF)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T519_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Archelaus (HF)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("AD")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T520_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Coponius (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Marcus Ambivius (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Annius Rufus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Valerius Gratus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("26")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Pontius Pilate (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("37")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Marullus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("41")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Herod Agrippa 1 (HF)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("44")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Fadus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("46")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Tiberius Alexander (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("48")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Cumanus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("52")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Felix (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("59")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Festus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("62")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Albinus (gov)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T520_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("64/65")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Florus (gov)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("(HF = Herod family;")]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("gov = Roman governor)")])]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_197"
    }
  }, [_vm._v("ROMAN")]), _vm._v(" LEADERS/EMPERORS")])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("BC")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T521_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("c.60")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Pompey, Julius Caesar, Crassus")])]), _vm._v(" "), _c('tr', {
    staticClass: "T521_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("49")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Julius Caesar")])]), _vm._v(" "), _c('tr', {
    staticClass: "T521_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("44")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Antony and Octavian (later Augustus)")])]), _vm._v(" "), _c('tr', {
    staticClass: "T521_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("31")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Augustus (first emperor)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("AD")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T522_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("14")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Tiberius")])]), _vm._v(" "), _c('tr', {
    staticClass: "T522_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("37")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Gaius Caligula")])]), _vm._v(" "), _c('tr', {
    staticClass: "T522_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("41")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Claudius")])]), _vm._v(" "), _c('tr', {
    staticClass: "T522_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("54")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Nero")])]), _vm._v(" "), _c('tr', {
    staticClass: "T522_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("68")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Galba")])]), _vm._v(" "), _c('tr', {
    staticClass: "T522_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("69")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Otho, Vitellius, Vespasian")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Pilate’s governorship came to an end suddenly, following his mishandling of a religious uprising in Samaria. A self-styled prophet, perhaps Messiah, had attracted a crowd to Mount Gerizim. Pilate sent in his troops, who inflicted heavy bloodshed. The result was a strong protest to the senior Roman governor of the area – based in Syria – who ordered Pilate back to Rome. Pilate’s failure to manage the religious affairs of his subjects wisely was finally his downfall.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("After Pilate")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Pilate’s immediate successor, Marullus (AD 37–41), presided over a crisis of the first order in AD 39, when the megalomaniac Roman emperor, Gaius Caligula, took offence at the Jews and ordered his statue to be set up in the Jerusalem temple itself. This looked like being another ‘desolating sacrilege’. The Jews were in uproar, and furious efforts were made to stop the order being carried out (including by Agrippa, one of the Herod family, who was a friend of Gaius). The thing that decisively saved the day was the death in Rome of Gaius by assassination.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Marullus was succeeded by Agrippa, the last of the Herods to have power in Jerusalem. He ruled from AD 41 to 44, and was popular with the Jews, living rather piously and also, according to the NT, taking action against the unpopular Christians (Acts 12:1–2).")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The following period of rule by Roman governors was turbulent. Fadus (AD 44–46) put down and beheaded a prophet called Theudas, who promised to lead people dry-foot through the Jordan to conquer the promised land. Tiberius Alexander (AD 46–48) crucified two sons of Judas the Galilean, presumably "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("for nationalist violence. His governorship was marked by a particularly severe period of famine. Cumanus (AD 48–52) presided over various troubles, including an incident in Jerusalem when a soldier offended Jewish sensitivities, leading to a disturbance in which, according to Josephus, 20,000 people were killed. There were also major tensions between Jews and Samaritans. The governorship of Felix (AD 52–60) saw more unrest in Palestine, with groups of revolutionaries or ‘zealots’ (such as the ‘sicarii’ who specialized in assassination) and religious prophets (including a Jew from Egypt) being active and gaining support. Felix was ruthless in response (Tacitus "), _c('em', [_vm._v("Hist")]), _vm._v(". 5:9). He was followed in office by Festus (AD 59–62), Albinus (AD 62–64/5) and Florus (AD 64/5–66), whose brutal and rapacious rule triggered rebellion, and the Jewish War. The Jews fought fiercely and hoped for a Maccabean-style deliverance; but it did not come, and the infighting between different groups in Jerusalem did nothing to help. In AD 70 Jerusalem was captured, the temple destroyed and burned down.")]), _vm._v(" "), _c('div', {
    staticClass: "C478"
  }, [_c('p', {
    staticClass: "C487"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_198"
    }
  }, [_vm._v("KEY")]), _vm._v(" DATES IN THE ROMAN PERIOD")])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("BC")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T524_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("63")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Judea becomes part of Roman empire.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T524_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("55")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Antipater (father of Herod the Great) given title ‘procurator of Judea’.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T524_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("44")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Julius Caesar murdered in Rome; Antipater murdered a year later.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T524_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("37")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Herod the Great captures Jerusalem, having previously been named king of Judea by the Romans.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T524_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Renovation of Jerusalem temple begun.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T524_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Approximate date of Jesus’ birth. Herod dies, to be succeeded by Archelaus in Judea and Samaria (until AD 6), Antipas in Galilee and Perea (until AD 39), Philip in area north of Galilee (until AD 33).")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C505"
  }, [_vm._v("AD")]), _vm._v(" "), _c('table', {
    staticClass: "C622",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T526_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Judea and Samaria put under direct Roman rule. Quirinius governor of Syria conducts census, provoking revolt led by Judas the Galilean.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T526_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("26")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Pontius Pilate governor of Judea until AD 36.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T526_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("31")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Approximate date of Jesus’ crucifixion and resurrection.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("39")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Roman emperor Gaius orders a statue of himself to be set up in Jerusalem temple.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("41")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Gaius assassinated. Herod Agrippa 1 appointed king of Judea, until his sudden death in AD 44.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("49")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Claudius, emperor, banishes Jews from Rome for rioting at the instigation of ‘Chrestus’. Many people killed in Jerusalem, due to incident involving Roman soldier.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("52")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Cumanus governor of Judea removed from office for poor handling of Jews and Samaritans. Succeeded by Felix, who has difficulties with Jewish nationalists including ‘sicarii’.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("59")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Festus governor.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("62")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Festus dies. High priest Annas 2 has James, brother of Jesus, killed, before arrival of new governor Albinus.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("64")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("The great fire in Rome, and persecution of Christians. Florus governor of Judea.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("66")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Jewish revolt begins in Jerusalem.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T528_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("70")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Jerusalem finally overrun after siege and bitter resistance.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C508"
  }, [_c('span', {
    attrs: {
      "id": "id_187"
    }
  }, [_c('img', {
    staticClass: "C687",
    attrs: {
      "alt": "",
      "src": "Images/39_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_213"
    }
  }, [_vm._v("Jesus’")]), _vm._v(" context")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The brief sketch that we have presented of the history has brought out various of the ingredients which made up Jesus’ world:")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Living under a pagan super-power")]), _vm._v(" From the time of the OT right through and into NT times, the Jews of Palestine had been living under the shadow of a powerful pagan superpower. In the "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("NT era Rome was militarily powerful, culturally vibrant, rich and pagan. Although the Romans did not seek to suppress Judaism, still the culture and way of life of the master race infiltrated Palestine, and many of the rich and influential people, notably the Herods, were into the Graeco-Roman way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The architecture, the entertainment and other aspects of the foreign rulers were attractive to many. Some of the Jews, for example the high-priestly families and the tax collectors, were doing very well under the Romans, and had a vested interest in the survival of the status quo. On the other hand, some of the Romans and other Gentiles found the religion of the Jews intriguing and their morality attractive.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Rich and poor")]), _vm._v(" People had been dispossessed to make room for the friends of the governing class, and the gap between rich and poor was wide. Taxation hit most people, often very hard – there were individual taxes, taxes on goods, as well as the traditional temple tax. Tax collectors were unscrupulous and unpopular. Debt was a major problem.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("A new desolating sacrilege")]), _vm._v(" There was also the fear of what might happen in the future, and of a new ‘desolating sacrilege’. The great fear was that the Romans might become much less benign, and defile things that Jews felt sacred. From time to time things did happen to enflame people’s anxieties. Whereas some of the Roman officials were shrewd and sensitive, some were provocative and even violent. Society was generally violent in a way that some of us can hardly imagine: crucifixions and massacres of people who opposed or offended the masters were commonplace.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Maintaining the traditions")]), _vm._v(" In face of the foreign imperialist, some people became lax about their old religious loyalties. Thus at the time of Antiochus Epiphanes a significant number of Jews were willing to go along with his introduction of Hellenistic culture. There was plenty of glamour and attraction in the Graeco-Roman culture and way of life. But many were spurred on to greater loyalty: in the absence of political freedom, the traditions of Judaism became all the more important as a mark of Jewish identity. In particular three things became especially sensitive:")]), _vm._v(" "), _c('div', {
    staticClass: "C464"
  }, [_c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the OT law;")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the call to be separate from everything unclean (including the unclean foreigner);")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("the temple.")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("These concerns motivated the Pharisees, and also the community at Qumran, though they felt that the temple in Jerusalem had been fatally compromised. (See further in "), _c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ch. 2")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Longing for change")]), _vm._v(" The OT books, especially the prophetic books, spoke of a day coming when God’s judgement would be removed from the people, when they would be free again, and there would be a new age of prosperity and salvation. The end of the Babylonian exile represented a partial fulfilment of that hope, but the experience since that time of living under the thumb of a variety of pagan superpowers left the Jews longing and praying for a more complete liberation, not least at Passover "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("time when they recalled God’s past deliverance from the superpower of Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The longing turned into action for some: individual leaders appeared, promising salvation and offering themselves as various sorts of messianic deliverers. People flocked to such people. In the NT itself there is mention of Judas and Theudas, not to mention John the Baptist and Jesus himself (Acts 5:36–37). There were also periodic uprisings against the Romans – people hoped that the Maccabean experience of victory through faith and heroism would be repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Religious confusion and division")]), _vm._v(" The situation encouraged a variety of religious responses, some justifying the status quo (at least tacitly), some advocating violent resistance, some maintaining religious purity but not violence, and others claiming that the Messiah or a Messiah had come. There was a level of tolerance within Judaism of different points of view, but a very limited level, and divisions could easily become violent, as they did between Jews and Samaritans. The most successful messianic movement was, of course, the Christian movement, and its very success made it the most divisive movement, threatening all sorts of people: its message of liberation from law and temple threatened the Pharisees and also the powerful temple authorities; its eventual inclusion of Gentiles threatened Jewish national identity.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Modern parallels?")]), _vm._v(" There are intriguing parallels between the situation of first-century Jewish Palestine and that in some modern Muslim countries: in first-century Palestine there was a struggle going on, at least culturally, between the pagan super-power and traditional Judaism. In many Muslim countries today modern Western secularism is the attractive, powerful paganism associated with the world super-power, America; it is very much in evidence in the capital cities of the world – bringing wealth to many and proving very attractive to many. But to the poor and pious, who often live in country areas (e.g. in Egypt), the secular threat is just that – a serious threat to their traditions, their culture, their family life. In that situation the fundamentalists flourish (compare the Pharisees), having great power with ordinary people; and so do the terrorists who attack tourist buses and other targets (compare the Jewish zealots – like Judas the Galilean – who were prepared to be violent in their opposition to Rome). Christians now, as then, are caught in a dilemma – being open to the charge of betraying the traditional faith and morals, even though they reject the secularism of the superpower.")]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_214"
    }
  }, [_vm._v("Essay")]), _vm._v(" topics")])]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("Introductory")])]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("What problems did the Romans face when ruling Jewish Palestine? What problems did the Jews have being ruled over by the Romans?")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("Why did people like Herod and Pilate want to get rid of people like John the Baptist and Jesus?")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("Intermediate")])]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("Why were the events of 167–164 BC of such importance to the Jews of Jesus’ day, and indeed to Jesus himself ?")]), _vm._v(" "), _c('p', {
    staticClass: "C542"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Further reading")])]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("Introductory")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_c('em', [_vm._v("DJG2")]), _vm._v(" articles: ‘Archaeology and Geography’, ‘Herodian Dynasty’, ‘Jerusalem’, ‘Rich and Poor’, ‘Rome’.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Frederick F. Bruce "), _c('em', [_vm._v("Israel and the Nations")]), _vm._v(", 3rd ed. revised by D. F. Payne. Carlisle: Paternoster, 1997/Downers Grove: IVP, 1998 (a reader-friendly history of Israel from OT times onwards).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Craig A. Evans "), _c('em', [_vm._v("Jesus and His World: The Archaeological Evidence")]), _vm._v(". London: SPCK, 2012 (discusses key evidence).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("John Riches "), _c('em', [_vm._v("The World of Jesus")]), _vm._v(". Cambridge: Cambridge University Press, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("John Stambaugh & David Balch "), _c('em', [_vm._v("The New Testament in its Social Environment")]), _vm._v(". Louisville: Westminster, 1986 (looks at the history and social environment of Jesus and the first Christians).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Gerd Theissen "), _c('em', [_vm._v("The Shadow of the Galilean")]), _vm._v(". London: SCM/Philadelphia: Fortress, 1987 (a brilliantly readable, semi-fictional account of Jesus’ Palestine).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Nick Page "), _c('em', [_vm._v("The Longest Week: The Truth about Jesus’ Last Days")]), _vm._v(". London: Hodder, 2009 (a popular account, strong on background).")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("Intermediate")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Kenneth E. Bailey "), _c('em', [_vm._v("Jesus Through Middle Eastern Eyes")]), _vm._v(". London: SPCK/Downers Grove: IVP, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("C. Kingsley Barrett "), _c('em', [_vm._v("The New Testament Background: Selected Documents")]), _vm._v(", 2nd ed. London: SPCK, 1987/New York: HarperSanFrancisco, 1995 (a useful collection of extracts from original documents).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Barry J. Beitzel, ed. "), _c('em', [_vm._v("Lexham Geographic Commentary on the Gospels")]), _vm._v(". Bellingham: Lexham, 2017; also "), _c('em', [_vm._v("Lexham Geographic Commentary on Acts through Revelation")]), _vm._v(". Bellingham: Lexham, 2019 (helpful: fills in key geographical material passage by passage).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Walter A. Elwell & Robert W. Yarborough "), _c('em', [_vm._v("Readings from the First Century World")]), _vm._v(". Grand Rapids: Baker, 1998 (a similar resource to Barrett).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Craig A. Evans & Stanley E. Porter, eds. "), _c('em', [_vm._v("Dictionary of New Testament Background")]), _vm._v(". Downers Grove/ Leicester, IVP: 2000 (an excellent resource).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Kenneth C. Hanson and David E. Oakman "), _c('em', [_vm._v("Palestine in the Time of Jesus")]), _vm._v(". 3rd ed., Minneapolis: Fortress, 2008 (helpful insights into the time, place and culture).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Emil Schürer "), _c('em', [_vm._v("The History of the Jewish People in the Age of Jesus Christ, 175 BC–AD 135, vol. 1.")]), _vm._v(" Edinburgh: T. & T. Clark, 1973 (a classic, thorough work, revised under the editorship of G. Vermes and F. Millar).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Mark D. Smith "), _c('em', [_vm._v("The Final Days of Jesus: The Thrill of Defeat, The Agony of Victory: A Classical Historian Explores Jesus’ Arrest, Trial, and Execution")]), _vm._v(". Cambridge: Lutterworth, 2018 (impressive use of the historical context to reconstruct the story).")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("David H. Wenkel "), _c('em', [_vm._v("Coins as Cultural Texts in the World of the New Testament")]), _vm._v(". London: Bloomsbury, 2017 (shows how coins give important cultural insights into the NT world).")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("There are two main editions of Josephus’ works in English:")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("William Whiston, "), _c('em', [_vm._v("The Works of Josephus")]), _vm._v(", revised ed. Peabody, MA: Hendrickson, 1987 (a new edition of an older translation – older editions can often be found second-hand).")]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("There are free online copies of Whiston’s translation too, e.g. at the Christian Classics Ethereal Library, <"), _c('a', {
    attrs: {
      "href": "http://www.ccel.org/ccel/josephus/works/files/works.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.ccel.org/ccel/josephus/works/files/works.html")]), _vm._v(">.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Works")]), _vm._v(", 10 vols, ed. H. StJ. Thackeray, Ralph Marcus, Allen Wikgren and Louis H. Feldman, LCL, London: Heinemann/Cambridge, MA: Harvard University Press, 1961–1989.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563db4db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/08_1The_historical_context_of_Jesus.vue
// module id = 75
// module chunks = 0